import { ViewMain } from './Components/View'

export const ManagerStockPersonalES = () => {

    return (
        <ViewMain />
    )
}
